import React from "react";

const GroupedTripLink = ({ id, label = id }) => (
  <a
    href={`/grouped_trips/${id}`}
    target="_blank"
    rel="noopener noreferrer"
    className="text-purple-700 hover:text-purple-900 hover:underline"
  >
    {label}
  </a>
);

export default GroupedTripLink;
